// extracted by mini-css-extract-plugin
export default {"popup":"OneTrustNotice_popup__X0X4m","close":"OneTrustNotice_close__DYFCi"};